<template>
  <div class="chatGroup">

    <div class="edit-area">
      <h2 class="normal">APP位置群</h2>
      <div class="normal">群名称：
        <div class="inputBox">
          <el-input v-model="name"></el-input>
        </div>
      </div>
      <div class="normal">城市：
        <div class="inputBox">
          <el-input v-model="inCity"></el-input>
        </div>
      </div>
      <div class="normal">群类别：
        <div class="inputBox">
          <el-input v-model="type" type="number"></el-input>
        </div>
      </div>

      <el-button type="primary" @click="upToDb">保存</el-button>
    </div>

    <div id="real_container" :style="mapHeight">
      <div class="map-botton">
        <div class="showNear" @click="showNearChats">查看周边</div>
      </div>
      <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult">
      </el-amap-search-box>
      <el-amap class="amap-box" vid="real_map" ref="real_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-marker v-if="markers.length>0" vid="real_search_marker" :position="markers"></el-amap-marker>
        <el-amap-marker vid="lnglat_marker" v-if="lnglat" :position="lnglat.split('|')"
          icon="./../../static/images/marker1.png">
          <!-- 新增或修改地段的点标记 -->
        </el-amap-marker>

        <el-amap-marker :vid="'boundary' + index" v-for="(pos,index) in boundary" :key="'boundary' + index"
          draggable="true"
          :events="boundaryEvents" :position="pos" :offset="[-16,-27]" icon="./../../static/images/marker.png">
          <!-- 边界 -->
        </el-amap-marker>
        <el-amap-polyline editable=false :path="boundaryPath" strokeColor="blue" strokeWeight=2></el-amap-polyline>

        <el-amap-marker :vid="'near_chats' + index" v-for="(item,index) in nearChats" :key="'near_chats' + index"
          draggable="true"
          :position="item.center.coordinates" :label="{content:item.name,offset:[10,12]}" icon="./../../static/images/marker4.png">
        </el-amap-marker>
        <el-amap-polyline v-for="(item,index) in nearCircle" :key="'nearline' + index" editable=false :path="item" strokeColor="#007eef" strokeWeight=2></el-amap-polyline>
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();

  export default {
    data() {
      return {
        mapHeight: {},
        searchOption: {
          citylimit: false
        },
        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        events: {
          'complete': () => {
            let that = this;
            let currentMap = amapManager.getMap();
            that.currentMap = currentMap;
            console.log('加载完成')
          },
          'click': (e) => {
            console.log('点击地图')
            let that = this
            that.lnglat = e.lnglat.lng + '|' + e.lnglat.lat;
          },
          'rightclick': (e) => {
            console.log('点击地图')
            let that = this
            that.boundary.push([e.lnglat.lng, e.lnglat.lat])
          }
        },
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        markers: '',
        boundaryEvents: {
          'rightclick': (e) => {
            let that = this;
            that.boundary.splice(e.target.w.vid.replace('boundary', ''), 1)
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('boundary', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.boundary.splice(index, 1, dot)
          }
        },

        boundary: [], // 边界，范围
        lnglat: '', // 中心点
        name: '', // 群名称
        type: '', // 群类别
        chat_id: '', // 群id
        nearChats: [],
        nearCircle: [],

        inCity: ''
      }
    },
    created() {
      let height = window.innerHeight + 'px';
      this.mapHeight.height = height
    },
    mounted() {},
    beforeRouteEnter(to, from, next) {
      if (from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if (!this.$route.meta.isBack) {
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.boundaryEvents;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack = false
    },
    methods: {
      init() {
        let that = this;
        let obj = that.$route.params
        if (obj.id) {
          that.$axios.post(that.$url_prefix + 'queryOneData', {
            match: {
              id: obj.id
            },
            db: 'GeoChatModel',
            projection: 'id name type boundary center city'
          }).then(function (res) {
            console.log(res)
            let data = res.data.data;
            that.boundary = data.boundary && data.boundary.coordinates || [];
            let center = data.center && data.center.coordinates;
            let lnglat = '';
            if (center && center.length) {
              lnglat = center.join('|');
              that.center = center;
            }
            that.lnglat = lnglat;
            that.name = data.name;
            that.type = data.type;
            that.chat_id = data.id;
            that.inCity = data.city;
          }).catch(function (res) {
            console.log('err', res)
            that.$message.error('查询失败，请检查网络')
          })
        }
      },

      onSearchResult(pois) { // 地图搜索
        if (pois.length > 0) {
          let {
            lng,
            lat
          } = pois[0];
          this.markers = [lng, lat];
          this.center = [lng, lat];
        }
      },

      upToDb() {
        let that = this;
        let name = that.name.trim();
        let type = Number(that.type);
        if (!name) {
          that.$message.error('请填写群名称');
          return;
        }
        if (!type) {
          that.$message.error('请填写群类别');
          return;
        }
        if (!that.lnglat) {
          that.$message.error('请标记中心点');
          return;
        }
        if (!that.boundary.length) {
          that.$message.error('请标记边界');
          return;
        }
        if (!that.inCity) {
          that.$message.error('请填写城市');
          return;
        }

        let obj = {
          name: name,
          type: type,
          center: {
            type: 'Point',
            coordinates: that.lnglat.split('|').map(x => Number(x))
          },
          boundary: {
            type: 'Polygon',
            coordinates: that.boundary
          },
          city: that.inCity
        }
        if (that.chat_id) {
          obj.id = that.chat_id;
        }
        let param = {
          'db': 'GeoChatModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('update', res);
          that.chat_id = '';
          that.boundary = [];
          that.lnglat = '';
          that.chat_id = '';
          that.name = '';
        }).catch(function (err) {
          that.$message.error('保存失败');
          console.log('err', err);
        })
      },

      showNearChats() {
        let that = this;
        if (that.lnglat) {
          that.$open();
          that.$axios.post(that.$url_prefix + 'getNearGeoChat', {
            center: that.lnglat.split('|').map(x => Number(x))
          }).then(res => {
            that.$close();
            console.log('getNearChats back', res);
            let list = res.data.data.filter(x => x.id !== that.chat_id);
            if (list.length === 0) {
              that.$message.error('附近没有建群');
            }
            let nearCircle = [];
            list.forEach(x => {
              let temp = x.boundary.coordinates;
              if (temp.length) {
                temp.push(temp[0]);
                nearCircle.push(temp);
              }
              delete x.boundary;
            })
            that.nearChats = list;
            that.nearCircle = nearCircle;
          }).catch(err => {
            that.$close();
            that.$message.error('查询出错');
            console.log('getNearChats err', err);
          })
        } else {
          that.$message.error('没有中心点');
        }
      },

    },

    computed: {
      boundaryPath() {
        let result = this.boundary.slice();
        if (result.length > 3) {
          result.push(result[0]);
        }
        return result;
      }
    }
  }

</script>

<style scoped>
  .chatGroup {
    display: flex;
    width: 100%;
    font-family: 'Gill Sans', 'Gill Sans MT', 'Calibri', 'Trebuchet MS', sans-serif;
  }

  .chatGroup .edit-area {
    text-align: center;
    width: 20%;
    overflow: hidden;
  }

  .chatGroup #real_container {
    width: 80%;
    position: relative;
  }

  #real_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .inputBox {
    display: inline-block;
    width: 50%;
  }

  .map-botton {
    text-align: center;
    line-height: 50px;
    position: absolute;
    left: 0;
    top: 50px;
    z-index: 6;
    display: flex;
    user-select: none;
  }
  .map-botton > div {
    cursor: pointer;
    padding: 0 10px;
    margin-right: 10px;
    border: 1px solid #cccccc;
  }
  .showNear {
    background-color: rgb(199, 199, 24);
  }
  .showAll {
    background-color: rgb(82, 122, 145);
  }

</style>



// WEBPACK FOOTER //
// src/page/GeoChat.vue